<template>
	<!-- 审核 -->
	<div class="check_situation">
		<div class="accident">
			<div class="tip">安全事故级别</div>
			<div class="drop_down" @click="showQuarter">
				<span v-if="!selectQuarter.text">请选择</span>
				<span class="selected" v-if="selectQuarter.text">{{
					selectQuarter.text
				}}</span>
				<img src="@/assets/appraise/arrow_right.png" alt />
			</div>
		</div>
		<div class="accident">
			<div class="tip">审核扣分</div>
			<div class="score">-{{ deductScore }}</div>
		</div>
		<div class="reason">
			<div class="reason_tit">扣分原因</div>
			<div class="content">
				<van-field v-model="deductReason" rows="6" autosize type="textarea" maxlength="500" placeholder="请输入扣分原因" show-word-limit />
			</div>
		</div>
		<div class="btn">
			<van-button @click="submit" type="primary" size="large" >提交</van-button>
		</div>
		<confirmDialog
			v-if="showDialog"
			:title="dialogTitle"
			:content="dialogContent"
			:cancelTxt="cancelBtn"
			:confirmTxt="confirmBtn"
			@confirm="confirm"
			@cancel="cancel"
		></confirmDialog>
		<commonPicker
			ref="commonPickerQuarter"
			:typeList="newQuarterList"
			:title="title"
			:cols="cols1"
			@getTypeValue="getTypeValue"
		></commonPicker>

        <tipDialog :isShow="showTips" :content="requireCont" @closeModal="showTips = false"></tipDialog>

	</div>
</template>

<script>
import confirmDialog from "../components/confirmDialog.vue";
import api from "@/service/modules/appraiseNew.js";
import commonPicker from "../../../components/base/myCommonPicker.vue";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
import tipDialog from "../travelNegative/components/tipDialog.vue";
export default {
	components: {
		confirmDialog,
		commonPicker,
		tipDialog,
	},
	data() {
		return {
			showDialog: false,
            showTips: false,
            requireCont: '',
			dialogTitle: "是否提交审核",
			dialogContent: "请确认该州（市）数据及扣分准确无误",
			cancelBtn: "",
			confirmBtn: "",
			deductReason: "",
			deductScore: "", // 扣分
			dataMsg: {},
			selectQuarter: {},
			newQuarterList: [
				[
					{ id: "1", text: "特大涉旅安全事故" },
					{ id: "2", text: "重大涉旅安全事故" },
					{ id: "3", text: "较大涉旅安全事故" },
					{ id: "4", text: "一般涉旅安全事故" },
					{ id: "5", text: "其他涉旅安全事故" },
				],
			],
			cols1: 1,
			title: "",
		};
	},
	created() {
		this.queryDetail();
	},
	methods: {
		showQuarter() {
			// 唤起事故等级选择组件
			this.$refs.commonPickerQuarter.showPicker();
		},
		// 查询详情
		queryDetail() {
			let params = {
				id: this.$route.query.id,
			};
			api.querySaveDetail(params).then((res) => {
				if (res.ret == 0) {
					this.dataMsg = res.data;
					this.selectQuarter.text = res.data.accidentLevelCN;
					this.deductScore = res.data.deduction / 100;
				}
			});
		},
		// 提交
		submit() {
			if ( !this.deductReason) {
                this.showTips = true;
                this.requireCont = '请填写扣分原因'
                return;
            }
			(this.dialogTitle = "是否提交审核"),
				(this.cancelBtn = "取消"),
				(this.confirmBtn = "提交"),
				(this.showDialog = true);
		},
		// 弹窗确认回调
		confirm() {
			const { area, year, quarter } = this.$route.query;
            this.showDialog = false;
			let params = {
				accidentLevel: this.dataMsg.accidentLevel,
				deduction: this.dataMsg.deduction,
				deductionReason: this.deductReason,
				id: this.dataMsg.id,
			};
			api.auditTripAccident(params).then((res) => {
				if (res.ret === 0) {
					this.$Toast({
						message: "审核成功",
						icon,
					});
					setTimeout(() => {
						this.$router.back(-1);
					}, 2000);
				}
			});
		},
		// 弹窗失败回调
		cancel() {
			this.showDialog = false;
		},
		getTypeValue(value) {
			this.selectQuarter = value[0];
			if (value[0].id === "1") {
				this.deductScore = 10;
			} else if (value[0].id === "2") {
				this.deductScore = 7;
			} else if (value[0].id === "3") {
				this.deductScore = 4;
			} else if (value[0].id === "4") {
				this.deductScore = 1;
			} else if (value[0].id === "5") {
				this.deductScore = 1;
			}
		},
	},
};
</script>

<style scoped lang="less">
.check_situation {
	padding: 9px 12px 0;
}
.accident {
	display: flex;
	justify-content: space-between;
	padding: 16px 0;
	height: 46px;
	border-bottom: 1px solid #ededed;
	.tip {
		color: #666;
		font-size: 14px;
	}
	.input input {
		text-align: right;
	}
	.input input::-webkit-input-placeholder {
		font-size: 14px;
		color: #ccc;
		text-align: right;
	}
	.drop_down {
		span {
			margin-right: 4px;
			color: #ccc;
			font-size: 14px;
		}
		img {
			display: inline-block;
			width: 12px;
			height: 12px;
			vertical-align: text-top;
		}
		span.selected {
			color: #333;
			font-size: 14px;
		}
	}
	.score {
		color: #666;
		font-size: 14px;
	}
}
.reason {
	.reason_tit {
		padding: 16px 0 12px;
		color: #666;
		font-size: 14px;
	}
	.content {
		.van-field {
			padding: 16px 12px 0;
			height: 180px;
			background-color: #f5f5f5;
		}
		/deep/ .van-field__body {
			height: 130px;
			textarea {
                max-height: 130px;
			}
		}
		/deep/ .van-field__word-limit {
			font-size: 14px;
			color: #333;
			span {
				color: #999;
			}
		}
	}
}
.btn {
	margin-top: 16px;
	::v-deep .van-button {
		width: 351px;
		height: 40px;
		background-color: #36b374;
	}
}
</style>
